module.exports = __webpack_public_path__ + "img/path-4.69e44b31.svg";